import Vue from 'vue';
import VueRouter from 'vue-router';
import { authGuard } from "../auth/authGuard";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/Home'),
        beforeEnter: authGuard,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {

        if (to.hash) {
            return {selector: to.hash};
        }

        if (savedPosition) {
            return savedPosition;
        }

        return { x: 0, y: 0 };

    },
});

export default router;
